<div class="today-performance-container" fxLayout="column" fxFill>
  <div class="full-width text-center">
    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.lt-md="5px">
      <ng-container *ngFor="let p of periods">
        <button class="btn-period" mat-raised-button [color]="p == period ? 'accent' : 'primary'"
          (click)="onChangePeriod(p)">
          {{ ('agent_panel.content.period_performance_' + p) | translate }}
        </button>
      </ng-container>
    </div>
    <!-- <mat-select [(ngModel)]="period" (selectionChange)="onChangePeriod($event.value)">
      <mat-option *ngFor="let p of periods" [value]="p">
        {{ ('agent_panel.content.period_performance_' + p) | translate }}
      </mat-option>
    </mat-select> -->
  </div>
  <div class="pa-1" fxLayout="column" fxLayoutGap="7px">
    <div>
      <h3 class="ma-0">{{currentUser?.name}}</h3>
    </div>
    <ng-template #tplDataNotFound>
      <mat-divider></mat-divider>
      <div>{{ 'public.data_not_found'|translate }}</div>
    </ng-template>
  </div>

  <ng-container *ngIf="singleUserDailyStats; else tplDataNotFound">
    <mat-divider></mat-divider>
    <div class="pa-1" fxLayout="column" fxLayoutGap="7px">
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          {{'daily_user_stats.content.connection_time'|translate}}
        </div>
        <div fxFlex="initial">
          {{singleUserDailyStats.connection_time|seconds_as_duration}}
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          {{'daily_user_stats.content.working_pause_time'|translate}}
        </div>
        <div fxFlex="initial">
          {{ (singleUserDailyStats.pause_time - singleUserDailyStats.non_working_pause_time)|seconds_as_duration }}
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          {{'daily_user_stats.content.non_working_pause_time'|translate}}
        </div>
        <div fxFlex="initial">
          {{singleUserDailyStats.non_working_pause_time|seconds_as_duration}}
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          {{'daily_user_stats.content.today_call_count'|translate}}
        </div>
        <div fxFlex="initial">
          {{singleUserDailyStats.outbound_call_count + singleUserDailyStats.inbound_call_answered}}
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          {{ 'daily_user_stats.content.acw'|translate }}
        </div>
        <div fxFlex="initial">
          {{singleUserDailyStats?.acw|seconds_as_duration}}
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          <span>
            {{'agent_panel.daily.qos'|translate}}
          </span>
        </div>
        <div fxFlex="initial">
          {{singleUserDailyStats?.qos || 0 }}%
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="pa-1" fxLayout="column" fxLayoutGap="7px" *ngIf="queueUserDailyStats">
      <div>
        <h3 class="ma-0">
          <span *ngIf="hasFeatureGroup && qosGroupNames; else GlobalGroupName" [matTooltip]="qosGroupNames">{{shortQosGroupName}}</span>
          <ng-template #GlobalGroupName>
            {{ 'public.global'|translate }}
          </ng-template>
        </h3>
      </div>

      <!-- <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          {{ 'daily_user_stats.content.acw'|translate }}
        </div>
        <div fxFlex="initial">
          {{queueUserDailyStats.acw}}
        </div>
      </div> -->
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="grow">
          <span>
            {{'agent_panel.daily.qos'|translate}}
          </span>
        </div>
        <div fxFlex="initial">
          {{queueUserDailyStats?.qos || 0 }}%
        </div>
      </div>

    </div>

    <mat-divider></mat-divider>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="px-1">
          <mat-panel-title>
            <span class="text-uppercase font-weight-bold">
              {{'agent_panel.content.inout_state_1'|translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="px-1 pb-1" fxLayout="column" fxLayoutGap="7px">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.inbound_call_count'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.inbound_call_count}}
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.inbound_call_answered'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.inbound_call_answered}}
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.communication_inbound'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.communication_inbound | seconds_as_duration}}
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.aht_inbound'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.aht_inbound | seconds_as_duration}}
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-divider></mat-divider>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="px-1">
          <mat-panel-title>
            <span class="text-uppercase font-weight-bold">
              {{'agent_panel.content.inout_state_2'|translate }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="px-1 pb-1" fxLayout="column" fxLayoutGap="7px">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.outbound_call_count'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.outbound_call_count}}
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.outbound_call_answered'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.outbound_call_answered}}
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.communication_outbound'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.communication_outbound | seconds_as_duration}}
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="grow">
              {{'daily_user_stats.content.aht_outbound'|translate}}
            </div>
            <div fxFlex="initial">
              {{singleUserDailyStats.aht_outbound|seconds_as_duration}}
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
  <!-- </mat-list> -->
</div>
